import * as actions from "../actions/edmi";

const edmisInitialState = {
  serial: null,
};

const edmisReducer = (state = edmisInitialState, action) => {
  switch (action.type) {
    case "RESET_STORE":
    case "LOGOUT_STORE":
    case actions.CLEAR_EDMI_SERIAL:
      return edmisInitialState;

    case actions.SET_EDMI_SERIAL:
      return {
        serial: action.payload.serial,
      };

    default:
      return state;
  }
};

export default edmisReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/edmi.js